<template>
  <div>
    <transition name="modalOverlay">
      <div class="dod_modal_overlay" v-if="show"></div>
    </transition>

    <div class="dod_modal" ref="dod">
      <div class="dod_modal_container" v-on:click="closeModal">
        <div class="dod13_modal">
          <div class="dod13_modal_inner" ref="modal" v-on:click.stop>
            <div class="dod_modal_resizer"
              ref="resizer"
              v-if="isSupportTouch"
              v-on:touchstart.stop="onTouchStart"
              v-on:touchmove.stop="onTouchMove"
              v-on:touchend.stop="onTouchEnd"
              v-touchfeedback>
            </div>
            <div class="dod13_modal_contentWrapper">
              <div class="dod13_modal_close" v-on:click.prevent="closeModal" v-touchfeedback>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <div class="dod13_modal_title">Say thanks 👋</div>
              <div class="dod13_modal_description">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
            </div>
            <div class="dod13_modal_actionWrapper">
              <div class="dod13_modal_actionButton is-positive" v-on:click.prevent="closeModalPositive" v-touchfeedback>
                <i class="icon material-icons">person</i>
                <span class="label">Profile</span>
              </div>
              <div class="dod13_modal_actionButton" v-on:click.prevent="closeModalPositive" v-touchfeedback>
                <i class="icon material-icons">add_circle</i>
                <span class="label">Follow</span>
              </div>
              <div class="dod13_modal_actionButton is-nagative" v-on:click.prevent="closeModalPositive" v-touchfeedback>
                <i class="icon material-icons">block</i>
                <span class="label">Block</span>
              </div>
            </div>
          </div>
        </div><!-- /dod13_modal -->

      </div><!-- /dod_modal_container -->
    </div><!-- /dod_modal -->
  </div><!-- /dod_modal -->
</template>

<script>
import anime from 'animejs'
import { TweenMax, Power4 } from 'gsap/TweenMax'
import { MQ_MAX } from '@/helpers/media-queries'

export default {
  name: 'Day13Modal',

  data: () => ({
    show: false,
    isMobile: false,
    isSupportTouch: false,
    lockToScrollPos: [0, 0],
    closeFlag: false
  }),

  methods: {
    closeModal() {
      this.show = false
      if (this.isMobile) {
        anime({
          targets: this.$refs.modal,
          translateY: ['0%', '100%'],
          translateZ: 0,
          opacity: 0,
          duration: 500,
          easing: 'cubicBezier(0.19, 1, 0.22, 1)',
          begin: () => {
            this.removeScrollListener()
            this.$emit('preclose')
          },
          complete: () => {
            this.$emit('close')
          }
        })
      } else {
        anime({
          targets: this.$refs.modal,
          skew: '5deg',
          rotate: '-5deg',
          translateY: [0, 100],
          opacity: {
            value: [1, 0],
            duration: 500
          },
          duration: 1000,
          easing: 'cubicBezier(0.19, 1, 0.22, 1)',
          begin: () => {
            this.removeScrollListener()
            this.$emit('preclose')
          },
          complete: () => {
            this.$emit('close')
          }
        })
      }
    },

    closeModalPositive() {
      this.show = false
      if (this.isMobile) {
        anime({
          targets: this.$refs.modal,
          opacity: {
            value: [1, 0],
            duration: 300
          },
          scale: {
            value: [1, 1.075],
            duration: 1000
          },
          duration: 300,
          easing: 'cubicBezier(0.19, 1, 0.22, 1)',
          begin: () => {
            this.removeScrollListener()
            this.$emit('preclose')
          },
          complete: () => {
            this.$emit('close')
          }
        })
      } else {
        anime({
          targets: this.$refs.modal,
          opacity: {
            value: [1, 0],
            duration: 300
          },
          scale: {
            value: [1, 1.075],
            duration: 1000
          },
          duration: 300,
          easing: 'cubicBezier(0.19, 1, 0.22, 1)',
          begin: () => {
            this.removeScrollListener()
            this.$emit('preclose')
          },
          complete: () => {
            this.$emit('close')
          }
        })
      }
    },

    handleWheel(e) {
      e.preventDefault()
    },

    handleScroll() {
      window.scrollTo(...this.lockToScrollPos)
    },

    onTouchStart(e) {
      e.stopPropagation()
      e.preventDefault()
      this.touchStart = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY
      }
    },

    onTouchMove(e) {
      if (this.closeFlag) {
        return true
      }

      const dx = e.changedTouches[0].clientX - this.touchStart.x
      const dy = e.changedTouches[0].clientY - this.touchStart.y
      const bottom = window.innerHeight - this.$refs.modal.offsetHeight - (Math.abs(dy) * 0.5)

      if (Math.abs(dy) > Math.abs(dx) && dy > 50) {
        e.stopPropagation()
        e.preventDefault()
        if (bottom < 150) {
          this.closeFlag = true
          this.closeModal()
        } else {
          TweenMax.killTweensOf(this.$refs.modal)
          TweenMax.to(this.$refs.modal, 0.4, {
            y: `${Math.abs(dy) * 1}px`,
            ease: Power4.easeOut
          })
        }
      }
    },

    onTouchEnd(e) {
      if (!this.closeFlag) {
        e.stopPropagation()
        e.preventDefault()
        TweenMax.killTweensOf(this.$refs.modal)
        TweenMax.to(this.$refs.modal, 0.4, {
          y: 0,
          ease: Power4.easeOut
        })
        this.$refs.modal.style.transform = null
      }
    },

    removeScrollListener() {
      document.removeEventListener('scroll', this.handleScroll, false)
      document.removeEventListener('wheel', this.handleWheel, false)
      document.removeEventListener('touchmove', this.handleWheel, false)
    }
  },

  mounted() {
    this.show = true

    if (this.isMobile) {
      anime({
        targets: this.$refs.modal,
        opacity: [0, 1],
        translateY: ['70%', '0%'],
        translateZ: 0,
        duration: 400,
        easing: 'easeOutElastic(1, 2)',
        delay: 200
      })
    } else {
      anime({
        targets: this.$refs.modal,
        opacity: {
          value: [0, 1],
          duration: 500
        },
        scale: {
          value: [0.9, 1],
          duration: 500
        },
        rotate: ['5deg', '0deg'],
        translateY: [100, 0],
        duration: 200,
        delay: 200,
        easing: 'cubicBezier(0.4, 0, 0.2, 1)'
      })
    }

    this.lockToScrollPos = [
      window.scrollLeft || window.scrollX,
      window.scrollTop || window.scrollY
    ]
  },

  created() {
    this.isSupportTouch = 'ontouchstart' in document
    this.isMobile = (MQ_MAX('T'))

    document.addEventListener('scroll', this.handleScroll, false)
    document.addEventListener('wheel', this.handleWheel, false)
    document.addEventListener('touchmove', this.handleWheel, false)
  },

  beforeDestroy() {
    this.removeScrollListener()
  }
}
</script>

<style scoped lang="scss">
.dod13_modal {
  @include FR_MQ_MIN(M) {
    @include FR_CENTER(xy);
    position: absolute;
  }
  @include FR_MQ_ONLY(QT) {
    margin-top: auto;
    position: relative;
  }
  @include FR_MQ_ONLY(QS) {
    margin-top: auto;
    position: relative;
  }
}

.dod13_modal_inner {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  opacity: 0;
  @include FR_MQ_MIN(M) {
    max-width: 400px;
    border-radius: 12.5px;
    margin-top: -2%;
  }
  @include FR_MQ_ONLY(QT) {
    border-radius: 3vw 3vw 0 0;
    padding: 0 0 8vw;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
    &:before {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 20vh;
      background-color: white;
    }
  }
  @include FR_MQ_ONLY(QS) {
    border-radius: 3vw 3vw 0 0;
    padding: 0 0 10vw;
    &:before {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 5vw;
      background-color: #ffffff;
    }
  }
}

.dod13_modal_close {
  @include FR_FLEX_LAYOUT(center, center);
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  padding: 6px;
  border-radius: 50%;
  background-color: rgba(#000000, 0.1);
  cursor: pointer;
  transition: background-color 200ms ease-out;
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  &.is-touch {
    background-color: rgba(#000000, 0.2);
  }
  @include FR_MQ_ONLY(QS) {
    top: 3vw;
    right: 3vw;
    width: 8vw;
    height: 8vw;
    padding: 1.5vw;
    display: none;
  }
}

/**************************************************
 * Modal > Content
 **************************************************/
.dod13_modal_contentWrapper {
  padding: 2rem;
  @include FR_MQ_ONLY(QT) {
    padding: 8vw 5vw (8vw * 0.9);
  }
  @include FR_MQ_ONLY(QS) {
    padding: 12vw 5vw (12vw * 0.9);
  }
}
.dod13_modal_title {
  font-size: 2em;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 1.5rem;
  padding-top: 0.5rem;
  @include FR_MQ_ONLY(QS) {
    font-size: 2.5em;
    margin-bottom: 1.5rem;
    padding-top: 0;
  }
}
.dod13_modal_description {
  opacity: 0.6;
}

/**************************************************
 * Modal > Action
 **************************************************/
.dod13_modal_actionWrapper {
  overflow: hidden;
}
.dod13_modal_actionButton {
  @include FR_FLEX_LAYOUT(flex-start, center);
  padding: 1.5em 2rem;
  line-height: 1;
  font-weight: bold;
  border-top: 1px solid rgba(#000000, 0.1);
  transition: background-color 200ms VAR(ease, md), color 200ms VAR(ease, md);
  cursor: pointer;
  color: rgba(#000000, 0.8);
  &.is-touch {
    background-color: #fafafa;
    color: #000000;
  }
  &.is-nagative {
    color: #D50000;
  }
  &.is-nagative.is-touch {
    background-color: #FF5252;
    color: #ffffff;
  }
  .dod13_modal_actionButton.is-touch + & {
    // border-top-color: #cccccc;
  }
  @include FR_MQ_ONLY(QT) {
    @include FONTSIZE(M, S);
    padding-top: 1.5em;
    padding-bottom: 1.5em;
    padding-left: 5vw;
    padding-right: 5vw;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      border-bottom: 1px solid rgba(#000000, 0.1);
    }
  }
  @include FR_MQ_ONLY(QS) {
    @include FONTSIZE(M, S);
    padding-top: 1.2em;
    padding-bottom: 1.2em;
  }
  > .icon {
    margin: 0;
    margin-right: 1rem;
    font-size: 1.6em;
  }
  > .label {
  }
}
</style>
